import React,{ useState, useEffect } from 'react'
import M from 'materialize-css'
import { axios } from '../../config'
import Loading from '../loading'

const NewPacking = () => {

	const [data, setData] = useState({contenedor:''})
	const [loader, setLoader] = useState(false)

	useEffect(()=>{
		M.updateTextFields()
		M.Datepicker.init(document.querySelector('#fechallegada'), {format:'yyyy-mm-dd',autoClose:false,i18n:{
			cancel:'cancelar',
			months:['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
			monthsShort: [ 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic' ],
			weekdays: [ 'Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado' ],
			weekdaysShort: [ 'Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab' ],
			weekdaysAbbrev:	['D','L','M','M','J','V','S'],
		},
			onClose:()=>{
			setData({...data,fechallegada:document.querySelector('#fechallegada').value})

			},
		});
		M.Timepicker.init(document.querySelectorAll('#horallegada'), {
			twelveHour:false,
			onCloseEnd:()=>{
				setData({...data,horallegada:document.querySelector('#horallegada').value})
			}
		});
	},[data])

	const _packing=(e)=>{
		var reader = new FileReader();
		reader.readAsDataURL(e.target.files[0]);
		reader.onload = () => {
			setData({...data,packing:reader.result})
		};
	}

	const _push=(e)=>{
		e.preventDefault()
		setLoader(true)
		axios.post('/api/newPacking',data)
		.then(r=>{
			setLoader(false)
			alert('Packing registrado')
			document.querySelector('#fechallegada').value='';
			document.querySelector('#horallegada').value='';
			document.querySelector('#input-file').value='';
			document.querySelector('#input-file-name').value='';
			setData({contenedor:''})
		})
		.catch(r=>alert(r))
	}

	return (
		<div className="container">
			<div className="row">
				<div className="card-panel">
					<h4>New PackingList</h4>
					<a href={axios.defaults.baseURL+'/plantillas/plantillaPacking.xlsx'} className='btn waves-effect waves-light right'>Descargar Plantilla</a>
					<form onSubmit={_push}>
					<div className="row">
						<div className="input-field">
							<input onChange={(e)=>setData({...data,contenedor:e.target.value})} value={data.contenedor||''} id="contenedor" required />
							<label htmlFor="contenedor">Numero de Contenedor</label>
						</div>
					</div>
					<div className="row">
						<div className="input-field">
							<input id="fechallegada" type="text" required/>
							<label htmlFor="fechallegada">Fecha de llegada</label>
						</div>
					</div>
					<div className="row">
						<div className="input-field">
							<input type="text" id="horallegada" required/>
							<label htmlFor="horallegada">Hora de llegada</label>
						</div>
					</div>
					<div className="row">
						<div className="input-field">
							<div className="file-field input-field">
								<div className="btn">
									<span>Packing</span>
									<input id='input-file' onChange={_packing} type="file" required/>
								</div>
								<div className="file-path-wrapper">
									<input id='input-file-name' className="file-path validate" type="text" required/>
								</div>
							</div>
						</div>
						{loader ? <Loading />:
						<button className="btn waves-effect waves-light right" type="submit" name="action">Subir
							<i className="material-icons right">send</i>
						</button>
						}
					</div>
					</form>
				</div>
			</div>
		</div>
	)
}

export default NewPacking
